import type { Store } from 'redux';
import { BaseMiddleware } from '@makemydeal/dr-activities-common';
import type { Selectors } from './selectors';
import type { HostActions } from '../types';
import { getDealPdf } from './actionMethods';
import { GET_DEAL_SUMMARY_PDF } from './actionTypes';
import { fetchDealProposals } from './multi-scenario/actionMethods';
import { GET_DEAL_PROPOSAL } from './multi-scenario/actionTypes';

export class MiddlewareManager extends BaseMiddleware {
    constructor(
        public selectors: Selectors,
        public hostActions: HostActions,
        public baseRoute?: string,
        public analyticsAction?: (store: any, key: string, desc: string) => void
    ) {
        super(selectors, analyticsAction);
    }

    /**
     * Activity-specific middleware. App-specific triggers (e.g. auto-fetch on the host's
     * deal-fetch-success) live in the app shell, not here.
     */
    protected middlewareFunction = (store: Store<any>, _next: any, action: any): void => {
        switch (action.type) {
            case GET_DEAL_SUMMARY_PDF: {
                store.dispatch(getDealPdf(this.selectors) as any);
                break;
            }
            case GET_DEAL_PROPOSAL: {
                if (this.selectors.additionalSelectors.isMultiScenarioOfferEnabled(store.getState())) {
                    store.dispatch(fetchDealProposals(this.selectors) as any);
                }
                break;
            }
            default:
                break;
        }
    };
}
